export default __webpack_public_path__ + "static/media/logo.28cea5a0.svg";